export type Commodity = {
  CommodityId: number | null;
  CommodityName: string;
  CommodityColor: string | null;
  CreationTimestamp?: string | null;
  UpdateTimestamp?: string | null;
  Author?: string | null;
  Comments?: string | null;
  IsEnable: boolean;
  IsActive: boolean;
  CommodityTypeId: number | null;
  CommodityTypeName?: string | null;
  IsDuplicate?: boolean;
};

export const COMMODITY_INITIAL_VALUES: Commodity = {
  CommodityId: null,
  CommodityName: "",
  CommodityColor: null,
  CreationTimestamp: null,
  UpdateTimestamp: null,
  Author: null,
  Comments: null,
  IsEnable: true,
  IsActive: true,
  CommodityTypeId: null,
  CommodityTypeName: null,
  IsDuplicate: false,
};
